// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterForm__hgroup":"oo_a bhh_a bhh_x","FilterForm__vgroup":"oo_b bhh_rp"};